import usePagination, { PaginationProps } from 'hooks/usePagination';
import InfiniteScroll from './InfiniteScroll';
import { PropsWithChildren } from 'react';

export default function InfinitePagination<R, V>(props: PropsWithChildren<PaginationProps<R, V> & { className?: string }>) {
  const { children, className, ...paginationProps } = props;

  const { handleLoadMore, hasNextPage, currentPage } = usePagination(paginationProps);

  return (
    <InfiniteScroll onEndReached={handleLoadMore} hasNextPage={hasNextPage} className={className}>
      {children}
    </InfiniteScroll>
  );
}
